
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/social-media-management",
      function () {
        return require("private-next-pages/social-media-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/social-media-management"])
      });
    }
  